import type { BaseItemSchema } from "@memorang/types";
import {
	confidenceRanges,
	getNewScoreMultiChoice,
	getTimeFactorForItem,
	normalizeScore,
} from "./functions";

// Calculates the new score for the quiz or practice question
export const calcScore = (
	confidence: number,
	correct: boolean,
	timeTaken: number,
	slideshowDurationInSeconds: number,
	question: BaseItemSchema,
) => {
	const { timeFactor, normalizedTimeTaken } = getTimeFactorForItem(
		question,
		timeTaken,
		slideshowDurationInSeconds,
	);

	const currentScore = 0;
	const newScore = getNewScoreMultiChoice({
		correct,
		confidence,
		currentScore,
		timeFactor,
	});

	const updatedScore = normalizeScore(newScore);

	// Makes sure that both correct and incorrect answers cannot exist with the same score
	const getFinalScore = () => {
		if (correct) {
			// Min score if correct
			const minScore = confidenceRanges[50][0];
			return Math.max(updatedScore, minScore);
		}
		// Max score if incorrect
		const maxScore = confidenceRanges[0][1];
		return Math.min(updatedScore, maxScore);
	};

	return {
		score: getFinalScore(),
		timeFactor,
		normalizedTimeTaken,
	};
};
